import { SocketBootstrapPayload } from 'src_common/common/websocket2/bootstrap/SocketBootstrap';

export const getSocketBootstrapData = (): SocketBootstrapPayload | null => {
    // Document undefined if server side
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return null;
    }

    try {
        const raw = document.documentElement.getAttribute('data-socket-bootstrap');
        if (raw === null || raw === '') {
            return null;
        }

        const parsed = JSON.parse(raw) as SocketBootstrapPayload;
        if (typeof parsed.queryKey !== 'string' || typeof parsed.from !== 'string' || typeof parsed.to !== 'string') {
            console.error('Invalid socket bootstrap payload shape');
            return null;
        }

        return parsed;
    } catch (error) {
        console.error('Failed to parse data-socket-bootstrap', error);
        return null;
    }
};
